var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { gql } from '@apollo/client';
var SIGNOUT = gql(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  mutation Signout {\n    me @rest(type: \"Signout\", method: \"DELETE\", endpoint: \"id\", path: \"/authentication_token\") {\n      NoResponse\n    }\n  }\n"], ["\n  mutation Signout {\n    me @rest(type: \"Signout\", method: \"DELETE\", endpoint: \"id\", path: \"/authentication_token\") {\n      NoResponse\n    }\n  }\n"])));
export default SIGNOUT;
var templateObject_1;
